import { createContext } from 'react'

import { UserContextType } from './userContext.types'

export const UserContext = createContext<UserContextType>({
  user: null
})
